import {Button} from "../../../Form/Button/Button";
import {buttonColors} from "../../../Pickers/InputTheme";
import React, {useState, useContext} from "react";
import './EditOrgNameCell.scss';
import {GridReactContext} from "../../../../Utils/DataGridWrapper/GridContext";
import { EditOrgNameModal } from '../../EditOrgNameModal/EditOrgNameModal';
import {I18nReactContext} from "../../../../contexts/I18nContext";


export const EditOrgNameCell = ({organizationId, organizationName}) => {
    const {i18n} = useContext(I18nReactContext);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const gridContext = useContext(GridReactContext)

    const onOpenModal = async () => {
        setIsModalOpen(true)
    }
    const onModalClose = () => {
        gridContext.triggerTableRefresh()
        setIsModalOpen(false)
    }

    return <div className="editOrgNameCell">
        <Button color={buttonColors.GREY}
                 size="small"
                 text={String(i18n.translate('organizationalUnitTable.editOrgNameCell.button'))}
                 onClick={onOpenModal}/>
        {
            isModalOpen && (
                <EditOrgNameModal
                    editOrgNameModalOpen={isModalOpen}
                    closeEditOrgNameModal={onModalClose}
                    organizationId={organizationId}
                    onSaveExternal={onModalClose}
                />
            )
        }
    </div>
}